import { create } from 'zustand';

import { Feedback, TelemetryEventCheck, UpdateFeedback } from '../feedback.types';

const DEFAULT_FEEDBACK: Feedback = {
    chosen_options: null,
    cluster_id: 1,
    custom_content: null,
    customer_name: null,
    customer_phone_number: null,
    customer_status: null,
    estimate: null,
    id: 0,
    inserted: '',
    pos_id: 1,
    prj_id: 1,
    transaction_id: null,
    updated: '',
    user_comment: null,
    user_priority: 1,
    questions: [],
    user_status: 1,
    vm_id: 1,
    voc_id: 1,
    wallet_user_id: null,
};

const DEFAULT_UPDATE_FEEDBACK: UpdateFeedback = {
    chosen_options: null,
    custom_content: null,
    customer_name: null,
    customer_phone_number: null,
    customer_status: null,
    estimate: null,
    id: 0,
};

interface FeedbackState {
    feedback: Feedback;
    updateFeedback: UpdateFeedback;
    telemetryEvent: TelemetryEventCheck;
    pageNumber: string;
    isPageNumberVisible: boolean;

    setFeedback: (fb: Feedback) => void;
    setUpdateFeedback: (uf: UpdateFeedback) => void;
    setTelemetryEvent: (te: TelemetryEventCheck) => void;
    setPageNumber: (pn: string) => void;
    setPageNumberVisible: (visible: boolean) => void;
}

export const useFeedbackStore = create<FeedbackState>((set) => ({
    feedback: DEFAULT_FEEDBACK,
    updateFeedback: DEFAULT_UPDATE_FEEDBACK,
    telemetryEvent: { id: null },
    pageNumber: '1/3',
    isPageNumberVisible: false,

    setFeedback: (feedback) => set({ feedback }),
    setUpdateFeedback: (uf) => set({ updateFeedback: uf }),
    setTelemetryEvent: (te) => set({ telemetryEvent: te }),
    setPageNumber: (pn) => set({ pageNumber: pn }),
    setPageNumberVisible: (visible) => set({ isPageNumberVisible: visible }),
}));
